import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useCart } from '../contexts/CartContext';
export function CloseSection() {
  const {
    addToCart
  } = useCart();
  return <section className="w-full bg-bg-secondary py-20 px-4" data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          {/* Section Label */}
          <p className="text-accent-red font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-48">
            The Close
          </p>

          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6" data-id="element-49">
            The Window Is Open. It Won't Stay That Way.
          </h2>

          <div className="space-y-6 text-lg text-text-secondary mb-8" data-id="element-50">
            <p data-id="element-51">
              Dormant follicles can be reactivated. Dead follicles cannot. Every
              month without intervention moves more of your follicles from the
              first category to the second.
            </p>
            <p data-id="element-52">
              The men who get the best results from this protocol are
              consistently the men who acted early — not because they were
              lucky, but because they still had follicles to work with.
            </p>
          </div>

          {/* Pull Quote */}
          <div className="bg-bg-primary border-l-4 border-accent-red rounded-lg p-8 mb-8" data-id="element-53">
            <p className="text-2xl text-text-primary italic font-medium text-center" data-id="element-54">
              "I wish I started earlier. That's the only thing I'd change."
            </p>
          </div>

          <div className="space-y-6 text-lg text-text-secondary mb-12" data-id="element-55">
            <p data-id="element-56">
              You've already done the research. You already know the mechanism
              is real. The only thing left is the decision.
            </p>
            <p className="font-semibold text-text-primary" data-id="element-57">
              You're either the man who acted when the window was open, or the
              man who waited.
            </p>
          </div>

          {/* Final CTA */}
          <div className="text-center mb-8" data-id="element-58">
            <h3 className="text-2xl font-bold text-text-primary mb-6" data-id="element-59">
              Take Control. Right Now.
            </h3>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-60">
            <CTAButton variant="primary" onClick={addToCart} ariaLabel="Order CrownControl for $497" data-id="element-61">
              ▶ ADD TO CART — $497
            </CTAButton>
            <div className="text-center space-y-1" data-id="element-62">
              <p className="text-sm text-text-muted" data-id="element-63">
                One-time payment · Free shipping · 180-Day Guarantee
              </p>
              <p className="text-sm text-text-muted" data-id="element-64">
                🔒 Secure checkout · Ships within 2 business days
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}